import React from 'react';
import PropTypes from 'prop-types';
import './Loader.scss';

const { Loader } = require('react-loaders');

const LoaderComponent = ({ isActive, absolute }) =>
  isActive ? (
    <div
      className={`loader__container ${
        absolute ? 'loader__container--absolute' : ''
      }`}
    >
      <Loader type={'ball-scale'} />
    </div>
  ) : null;

LoaderComponent.defaultProps = {
  absolute: false,
};

LoaderComponent.propTypes = {
  absolute: PropTypes.bool,
  isActive: PropTypes.bool.isRequired,
};

export default LoaderComponent;
